/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FeedbackRating,
    FeedbackRatingFromJSON,
    FeedbackRatingFromJSONTyped,
    FeedbackRatingToJSON,
} from './FeedbackRating';

/**
 * 
 * @export
 * @interface EventRegistrationParams
 */
export interface EventRegistrationParams {
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    registration_id: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    order_receipt_number: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    registration_status: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    option_name: string;
    /**
     * 
     * @type {FeedbackRating}
     * @memberof EventRegistrationParams
     */
    feedback_rating: FeedbackRating;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    feedback_comments: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    attendee_full_name: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    attendee_first_name: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    attendee_last_name: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    attendee_email: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    attendee_phone: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    attendee_date_of_birth: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    attendee_age: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    attendee_gender: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    attendee_medical_history: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    attendee_dietary_restrictions: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    contact_name: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    contact_email: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    contact_phone: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    contact_address: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    contact_postcode: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    contact_relation: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    attendee_parent_name: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    attendee_emergency_contact_phone: string;
    /**
     * 
     * @type {string}
     * @memberof EventRegistrationParams
     */
    attendee_emergency_contact_email: string;
    /**
     * 
     * @type {Date}
     * @memberof EventRegistrationParams
     */
    registration_created: Date;
}

export function EventRegistrationParamsFromJSON(json: any): EventRegistrationParams {
    return EventRegistrationParamsFromJSONTyped(json, false);
}

export function EventRegistrationParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventRegistrationParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'registration_id': json['registration_id'],
        'order_receipt_number': json['order_receipt_number'],
        'registration_status': json['registration_status'],
        'option_name': json['option_name'],
        'feedback_rating': FeedbackRatingFromJSON(json['feedback_rating']),
        'feedback_comments': json['feedback_comments'],
        'attendee_full_name': json['attendee_full_name'],
        'attendee_first_name': json['attendee_first_name'],
        'attendee_last_name': json['attendee_last_name'],
        'attendee_email': json['attendee_email'],
        'attendee_phone': json['attendee_phone'],
        'attendee_date_of_birth': json['attendee_date_of_birth'],
        'attendee_age': json['attendee_age'],
        'attendee_gender': json['attendee_gender'],
        'attendee_medical_history': json['attendee_medical_history'],
        'attendee_dietary_restrictions': json['attendee_dietary_restrictions'],
        'contact_name': json['contact_name'],
        'contact_email': json['contact_email'],
        'contact_phone': json['contact_phone'],
        'contact_address': json['contact_address'],
        'contact_postcode': json['contact_postcode'],
        'contact_relation': json['contact_relation'],
        'attendee_parent_name': json['attendee_parent_name'],
        'attendee_emergency_contact_phone': json['attendee_emergency_contact_phone'],
        'attendee_emergency_contact_email': json['attendee_emergency_contact_email'],
        'registration_created': (new Date(json['registration_created'])),
    };
}

export function EventRegistrationParamsToJSON(value?: EventRegistrationParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'registration_id': value.registration_id,
        'order_receipt_number': value.order_receipt_number,
        'registration_status': value.registration_status,
        'option_name': value.option_name,
        'feedback_rating': FeedbackRatingToJSON(value.feedback_rating),
        'feedback_comments': value.feedback_comments,
        'attendee_full_name': value.attendee_full_name,
        'attendee_first_name': value.attendee_first_name,
        'attendee_last_name': value.attendee_last_name,
        'attendee_email': value.attendee_email,
        'attendee_phone': value.attendee_phone,
        'attendee_date_of_birth': value.attendee_date_of_birth,
        'attendee_age': value.attendee_age,
        'attendee_gender': value.attendee_gender,
        'attendee_medical_history': value.attendee_medical_history,
        'attendee_dietary_restrictions': value.attendee_dietary_restrictions,
        'contact_name': value.contact_name,
        'contact_email': value.contact_email,
        'contact_phone': value.contact_phone,
        'contact_address': value.contact_address,
        'contact_postcode': value.contact_postcode,
        'contact_relation': value.contact_relation,
        'attendee_parent_name': value.attendee_parent_name,
        'attendee_emergency_contact_phone': value.attendee_emergency_contact_phone,
        'attendee_emergency_contact_email': value.attendee_emergency_contact_email,
        'registration_created': (value.registration_created.toISOString()),
    };
}

